import { useMutation } from 'react-query';
import qs from 'qs';
import api from 'src/services/api';
import { useContext } from 'react';
import { TeamDashContext } from 'src/pagesDashboard/DashTeam/context/Provider';
import blobUtils from 'src/utils/blob';
import { COMPANY_EXPORT_VIEWS } from 'common/commonCompanyUtils';

const getQueryParams = () => {
  const { context } = useContext(TeamDashContext);
  const {
    reviewerIds, revieweeIds, roleIds, reportIsSelf, reportStatus
  } = context;
  const { value, start, end } = context.range;

  const filters = {
    range: value,
    start,
    end,
    reviewerIds,
    revieweeIds,
    roleIds,
    reportIsSelf,
    reportStatus
  };
  return { filters, options: {} };
};

// query to get a company's overview or reports tab data in a spreadsheet
export const exportCompanyQuery = (view) => {
  const isExportUsersView = view === COMPANY_EXPORT_VIEWS.USERS;
  const exportUsersParams = {
    filters: {},
    options: {}
  };

  const { filters, options } = !isExportUsersView
    ? getQueryParams()
    : exportUsersParams;
  options.view = view;

  return useMutation(async (filename) => {
    const params = qs.stringify({ filters, options }, { skipNulls: true });
    const blob = await api.getXLS(`/company/export?${params}`);
    blobUtils.triggerBlobDownload(blob, filename);
  });
};
